<template>
  <div class="footer-social">
    <a
      v-for="(icon, index) in icons"
      :key="`icon-${index}`"
      class="footer-social__anchor"
      :class="{
        'footer-social__anchor--mobile-hidden': !icon.isVisibleOnMobile,
        'footer-social__anchor--strava': icon.href === SM_STRAVA_URL,
        'footer-social__anchor--ig': icon.href === SM_INSTAGRAM_URL,
        'footer-social__anchor--facebook': icon.href === SM_FACEBOOK_URL,
      }"
      :href="icon.href"
      target="_blank"
      v-data-test-id="'icon'"
    >
      <component :is="icon.component" class="footer-social__icon" />
    </a>
  </div>
</template>

<script>
import {
  SM_FACEBOOK_URL,
  SM_INSTAGRAM_URL,
  SM_LINKEDIN_URL,
  SM_STRAVA_URL,
  SM_TWITTER_URL,
  SM_YOUTUBE_URL,
} from '@/config/constants'
import IconFacebook from '@/components/_icons/IconFacebook.svg'
import IconInstagram from '@/components/_icons/IconInstagram.svg'
import IconLinkedIn from '@/components/_icons/IconLinkedIn.svg'
import IconStrava from '@/components/_icons/IconStrava.svg'
import IconTwitter from '@/components/_icons/IconTwitter.svg'
import IconYoutube from '@/components/_icons/IconYoutube.svg'

export default {
  name: 'FooterSocial',
  data() {
    return {
      SM_FACEBOOK_URL,
      SM_INSTAGRAM_URL,
      SM_STRAVA_URL,
      icons: [
        {
          component: IconFacebook,
          href: SM_FACEBOOK_URL,
          isVisibleOnMobile: true,
        },
        {
          component: IconInstagram,
          href: SM_INSTAGRAM_URL,
          isVisibleOnMobile: true,
        },
        {
          component: IconLinkedIn,
          href: SM_LINKEDIN_URL,
          isVisibleOnMobile: false,
        },
        {
          component: IconStrava,
          href: SM_STRAVA_URL,
          isVisibleOnMobile: false,
        },
        { component: IconTwitter, href: SM_TWITTER_URL, isVisibleOnMobile: false },
        {
          component: IconYoutube,
          href: SM_YOUTUBE_URL,
          isVisibleOnMobile: true,
        },
      ],
    }
  },
}
</script>

<style lang="scss" scoped>
@import './footer-settings';
$all-icons-bp: 410px;
$border-style: 1px solid rgba($c-white, 0.6);
$icon-padding: 10px;

.footer-social {
  position: relative;
  top: -$icon-padding;
  right: -$icon-padding;

  &__anchor {
    display: inline-block;
    padding: $icon-padding;

    &--mobile-hidden {
      display: none;

      @media (min-width: $all-icons-bp) {
        display: inline-block;
      }
    }

    &--facebook {
      @media (min-width: $all-icons-bp) {
        padding: 0 9px 0 10px;
      }
    }

    &--strava {
      padding: 0 6px 0 4px;
    }

    &--ig {
      padding-right: 17px;

      @media (min-width: $all-icons-bp) {
        padding-right: 11px;
      }
    }
  }

  &__icon {
    fill: rgba($color_white, 0.4);
    width: 20px;
    height: 20px;
    transition: fill $transition-time;

    &:hover {
      fill: $c-white;
    }
  }
}
</style>
